var annualPricesGermanyA1 = {
    Child: { BASIC: 1320, PREMIUM: 2111 },
    '18-25': { BASIC: 2014, PREMIUM: 3244 },
    '26-29': { BASIC: 2415, PREMIUM: 3901 },
    '30-34': { BASIC: 2613, PREMIUM: 4217 },
    '35-39': { BASIC: 3036, PREMIUM: 4896 },
    '40-44': { BASIC: 3371, PREMIUM: 5430 },
    '45-49': { BASIC: 3869, PREMIUM: 6239 },
    '50-54': { BASIC: 4958, PREMIUM: 8172 },
    '55-59': { BASIC: 6547, PREMIUM: 10100 },
    '60-64': { BASIC: 8845, PREMIUM: 12931 },
    '65-69': { BASIC: 13295, PREMIUM: 19048 },
    '70-74': { BASIC: 19132, PREMIUM: 26733 },
    '75-79': { BASIC: 25783, PREMIUM: 32133 },
    '80+': { BASIC: 32265, PREMIUM: 38970 },
};
var annualPricesGermanyA2 = {
    Child: { BASIC: 3561, PREMIUM: 5695 },
    '18-25': { BASIC: 5430, PREMIUM: 8763 },
    '26-29': { BASIC: 6525, PREMIUM: 10533 },
    '30-34': { BASIC: 7055, PREMIUM: 11385 },
    '35-39': { BASIC: 8197, PREMIUM: 13220 },
    '40-44': { BASIC: 9099, PREMIUM: 14665 },
    '45-49': { BASIC: 10446, PREMIUM: 16840 },
    '50-54': { BASIC: 13387, PREMIUM: 22058 },
    '55-59': { BASIC: 17667, PREMIUM: 27270 },
    '60-64': { BASIC: 23886, PREMIUM: 34914 },
    '65-69': { BASIC: 35892, PREMIUM: 51453 },
    '70-74': { BASIC: 51653, PREMIUM: 72202 },
    '75-79': { BASIC: 69612, PREMIUM: 86836 },
    '80+': { BASIC: 86928, PREMIUM: 105073 },
};
var annualPricesA1 = {
    Child: { BASIC: 1396, PREMIUM: 2232 },
    '18-25': { BASIC: 2128, PREMIUM: 3431 },
    '26-29': { BASIC: 2555, PREMIUM: 4125 },
    '30-34': { BASIC: 2764, PREMIUM: 4459 },
    '35-39': { BASIC: 3210, PREMIUM: 5178 },
    '40-44': { BASIC: 3565, PREMIUM: 5743 },
    '45-49': { BASIC: 4091, PREMIUM: 6596 },
    '50-54': { BASIC: 5242, PREMIUM: 8640 },
    '55-59': { BASIC: 6923, PREMIUM: 10678 },
    '60-64': { BASIC: 9354, PREMIUM: 13675 },
    '65-69': { BASIC: 14058, PREMIUM: 20142 },
    '70-74': { BASIC: 20231, PREMIUM: 28267 },
    '75-79': { BASIC: 27264, PREMIUM: 33978 },
    '80+': { BASIC: 34117, PREMIUM: 41206 },
};
var annualPricesA2 = {
    Child: { BASIC: 3765, PREMIUM: 6023 },
    '18-25': { BASIC: 5743, PREMIUM: 9266 },
    '26-29': { BASIC: 6899, PREMIUM: 11136 },
    '30-34': { BASIC: 7461, PREMIUM: 12038 },
    '35-39': { BASIC: 8666, PREMIUM: 13979 },
    '40-44': { BASIC: 9621, PREMIUM: 15508 },
    '45-49': { BASIC: 11046, PREMIUM: 17807 },
    '50-54': { BASIC: 14156, PREMIUM: 23325 },
    '55-59': { BASIC: 18682, PREMIUM: 28837 },
    '60-64': { BASIC: 25258, PREMIUM: 36919 },
    '65-69': { BASIC: 37951, PREMIUM: 54406 },
    '70-74': { BASIC: 54618, PREMIUM: 76346 },
    '75-79': { BASIC: 73609, PREMIUM: 91820 },
    '80+': { BASIC: 91918, PREMIUM: 111105 },
};
export var deductibleMultipliers = {
    0: 1,
    150: 0.95,
    375: 0.9,
    750: 0.85,
    1500: 0.8,
    3750: 0.7,
    7500: 0.6,
    15000: 0.5,
};
export var annualPricesGermany = {
    AREA_ONE: annualPricesGermanyA1,
    AREA_TWO: annualPricesGermanyA2,
};
export var annualPrices = {
    AREA_ONE: annualPricesA1,
    AREA_TWO: annualPricesA2,
};
